var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-buttons"},[_c('router-link',{staticClass:"sk-btn sk-btn--default booking-buttons__btn",attrs:{"to":_vm.postInterpretationLink,"replace":""}},[_vm._v(_vm._s(_vm.$gettext('Book an interpreter')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }